module.exports = __webpack_public_path__ + "img/heading-bg.ec44e646.svg";